import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import "./progress-indicator.scss";

const ProgressIndicator = ({ className, currentStep, totalSteps, children }) => {
  const classes = classnames("progress-indicator", className);
  const scale = `scaleX(${currentStep / totalSteps})`;
  return (
    <div className={classes}>
      <span className="show-for-sr progress-bar__status-txt">
        Your current progress: step {currentStep} of {totalSteps}
      </span>
      <div className="progress-indicator__line">
        <div className="progress-indicator__line-inner" style={{ transform: scale }} />
      </div>

      <ol className="progress-indicator__list" aria-hidden="true">
        {Array.from(Array(totalSteps)).map((item, i) => {
          const step = i + 1;
          const itemClasses = classnames("progress-indicator__list-item", {
            "is-active": step === currentStep,
          });
          return (
            <li key={i} className={itemClasses}>
              <span className="hide">Section {step}</span>
            </li>
          );
        })}
      </ol>
      {children}
    </div>
  );
};

ProgressIndicator.propTypes = {
  className: PropTypes.string,
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default ProgressIndicator;
